import { useState } from "react";
import { useNavigate } from "react-router-dom";
import baseUrl from "../vars";
import { authFetch } from "../auth/auth";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import {
  Button,
  Input,
  Text,
  useToast,
  VStack,
  Progress
} from "@chakra-ui/react";

const LoadFilePage = observer(() => {
  const { pageStore } = useStores();
  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();

  const toast = useToast();

  const [file, setFile] = useState("");


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const uploadFile = async () => {
    if (!file) return;

    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("file_up", file);

      const response = await authFetch(`${baseUrl}/api/upload/profit`, {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${pageStore.token}`,
        },
        body: formData,
      });

      if (response.ok) {
        toast({
          title: "Успех",
          description: "Файл успешно загружен",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error("Ошибка загрузки");
      }
    } catch (err) {
      toast({
        title: "Ошибка",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <Text
        marginTop={"20px"}
        color={"myColor.brightBlue"}
        fontWeight={"600"}
        fontSize={"24px"}
        marginLeft={"100px"}
      >
        Загрузка
      </Text>
      <Text color={"myColor.white"} marginLeft={"100px"}>
        Страница для загрузки файла
      </Text>

      <VStack
        gap={0}
        padding={"0 20px"}
        marginTop={"20px"}
        align={"flex-start"}
      >
        <Text fontWeight={"600"} color={"myColor.white"}>
          Выберите файл
        </Text>
        <Input
          type="file"
          accept=".xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={handleFileChange}
          border={"none"}
          padding={0}
          color={"myColor.white"}
        />
        <Button
          onClick={uploadFile}
          isDisabled={isUploading}
          bg={"myColor.commonBlue"}
          color={"myColor.white"}
          _hover={{
            bg: "myColor.darkBlue",
            color: "myColor.green",
          }}
          cursor={isUploading ? "not-allowed" : "pointer"}
        >
          {isUploading ? "Загрузка..." : "Загрузить"}
        </Button>

        {isUploading && (
          <Progress
            size="sm"
            isIndeterminate
            width="100%"
            colorScheme="blue"
            marginTop="10px"
          />
        )}

        {uploadStatus && <Text marginTop={"10px"}>{uploadStatus}</Text>}
      </VStack>
    </VStack>
  );
});

export default LoadFilePage;
